import React, { Component } from 'react';
import {
  PopupboxManager,
  PopupboxContainer
} from 'react-popupbox';
import 'react-popupbox/dist/react-popupbox.css'
import './style.css';
const popupboxConfig = {
  titleBar: {
    enable: true,
  },
  fadeIn: true,
  fadeInSpeed: 500
}
export default class LightboxText extends Component {
  openPopupbox(content) {
    PopupboxManager.open({ content })
  }

  render() {
    return (
      <div>
        <PopupboxContainer  { ...popupboxConfig } />
      </div>
    )
  }
}